



























































































































import SignDocumentSideCard from "@/components/sign-document/SignDocumentSideCard.vue";
import TagPreview from "@/components/tag/TagPreview.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { IControlElements } from "@/components/utility/TableWrapper.vue";
import Tooltip from "@/components/utility/tooltip.vue";
import PaginatedTable from "@/components/utility/v2/PaginatedTable.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { ITableWrapperHeader } from "@/lib/types/tableWrapper";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { $t } from "@/lib/utility/t";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { IReference } from "@/models/reference.entity";
import { ISignDocument, SignDocument } from "@/models/sign-document.entity";
import { ISignRequest } from "@/models/sign-request.entity";
import { ITag } from "@/models/tag.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";
import { DocumentModule } from "@/store/modules/document.store";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import SignDocumentCreateDialog from "./DocumentCreateDialog.vue";
import DocumentManageAccessDialog from "./DocumentManageAccessDialog.vue";
import DragMixin from "./DragMixin.vue";
import ReportDocumentSignRequestDialog from "./ReportDocumentSignRequestDialog.vue";
import SignRequestCreateDialog from "./SignRequestCreateDialog.vue";
import { PaginatedBaseStore } from "@/store/paginated-base.store";
import { SignDocumentControllerFindAllParamsGen } from "@/services/sign/v1/data-contracts";
import DragMultipleMixin from "./DragMultipleMixin.vue";
import { handleError } from "@/lib/utility/handleError";
import { TYPE } from "vue-toastification";
import { HttpException, InternalServerErrorException } from "@/lib/exceptions/http";

@Component({
  components: {
    Tooltip,
    TheLayoutPortal,
    SignDocumentCreateDialog,
    SignRequestCreateDialog,
    ConfirmActionDialog,
    ReportDocumentSignRequestDialog,
    PaginatedTable,
    SignDocumentSideCard,
    TagPreview,
    DocumentManageAccessDialog
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class DocumentTable extends mixins(DragMultipleMixin) {
  @Ref("signRequestDialog")
  signRequestDialog!: ReportDocumentSignRequestDialog;

  @Ref("signDocumentCreateDialog")
  signDocumentCreateDialog!: SignDocumentCreateDialog;

  @Prop({ default: false })
  load!: boolean;

  @Prop({ default: false })
  isTemplate!: boolean;

  @Prop({ default: () => [] })
  refs!: IReference[];

  @Prop({ default: () => [] })
  filters!: IPageFilterElement[];

  @Prop({ default: () => [] })
  tags?: ITag[];

  /**
   * Title of the table
   */
  @Prop({ required: false })
  title?: string;

  @Prop()
  module?: PaginatedBaseStore<ISignDocument, SignDocumentControllerFindAllParamsGen>;

  @Prop({ default: () => [] })
  additionalControlElements!: IControlElements[];

  @Prop({ default: false })
  hideCreate!: boolean;

  @Prop({})
  showFolder!: boolean;

  @Prop({})
  showIsTemplate!: boolean;

  get store() {
    if (this.module) {
      return this.module;
    }

    return DocumentModule;
  }

  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;
  PartnerTypeEnum = PartnerTypeEnum;

  isLoadingAll = false;
  isLoading = false;

  acceptImage = false;

  /**
   * Opening delete confirmation
   */
  isDeleteDialogActive = false;
  isDeleteDialogLoading = false;

  search = "";

  itemsPerPage = 25;

  snack = false;
  snackColor = "";
  snackText = "";

  expanded = [];
  selected: ISignDocument[] = [];

  createSignRequest = false;
  documentManageAccessDialog = false;

  selectedDocument: ISignDocument | null = null;
  documentToUpdate: ISignDocument | null = null;

  get headers(): ITableWrapperHeader[] {
    const headers: ITableWrapperHeader[] = [
      { text: $t("sign.DocumentTable.created"), align: "start", width: "120px", value: "timestamp.created" },
      { text: $t("sign.DocumentTable.type"), align: "start", value: "isTemplate", width: 80 }
    ];

    if (this.partner.partnerType === PartnerTypeEnum.BROKER) {
      headers.push({ text: $t("objects.document.isInternal"), align: "start", value: "isShared", width: 90 });
    }

    headers.push(
      { text: $t("sign.DocumentTable.internalTitle"), align: "start", value: "title" },
      { text: $t("tag.tags"), align: "start", value: "tags" },
      { text: $t("sign.DocumentTable.modified"), align: "end", value: "timestamp.lastModified", width: "120px" },
      { text: "", align: "end", value: "controls", width: 120, sortable: false }
    );

    return headers;
  }

  async onDrop(files: File[]) {
    if (files.length === 1) {
      const document = new SignDocument({ file: files[0], tags: this.tags || [] });
      this.signDocumentCreateDialog.showWithDocument(document);

      return;
    }

    this.isLoading = true;

    const toastId = this.$toast($t("components.DropAreaMulti.processing", { length: files.length }), {
      type: TYPE.INFO,
      timeout: false,
      showCloseButtonOnHover: true,
      onClick: (closeToast: Function) => {
        closeToast();
      }
    });

    try {
      const fp: Promise<void | ISignDocument>[] = [];
      for (const file of files) {
        fp.push(
          new SignDocument({
            name: file.name,
            title: file.name,
            partnerId: this.partner.id,
            file,
            refs: this.refs
          }).create()
        );
      }

      await Promise.all(fp);

      this.$toast.update(toastId, {
        content: this.$t("completed").toString(),
        options: {
          type: TYPE.SUCCESS,
          timeout: 2000
        }
      });

      return files;
    } catch (error) {
      this.$log.error(error);

      if (error instanceof HttpException) {
        if (error instanceof InternalServerErrorException) {
          this.$toast.update(toastId, {
            content: $t("InternalServerErrorException"),
            options: {
              type: TYPE.ERROR,
              timeout: 2000
            }
          });
        } else {
          this.$toast.update(toastId, {
            content: error.message,
            options: {
              type: TYPE.ERROR,
              timeout: 2000
            }
          });
        }
      } else {
        this.$toast.update(toastId, {
          content: $t("loadingError"),
          options: {
            type: TYPE.ERROR,
            timeout: 2000
          }
        });
      }
    } finally {
      this.isLoading = false;
    }
  }

  createDocument() {
    const document = new SignDocument({ tags: this.tags || [] });
    this.signDocumentCreateDialog.showWithDocument(document);
  }

  @Watch("isTemplate")
  setIsTemplateFilter(value: boolean) {
    this.store.setFilters([
      new PageFilterElement({
        key: "isTemplateFilter",
        operation: PageFilterOperationEnum.EQUAL,
        value: value.toString()
      })
    ]);
  }

  beforeMount() {
    const filters: IPageFilterElement[] = [...(this.filters ?? [])];
    if (this.refs) {
      this.refs.forEach(ref => {
        filters.push(
          new PageFilterElement({
            key: "refs.refId",
            operation: PageFilterOperationEnum.EQUAL,
            value: ref.refId
          }),
          new PageFilterElement({
            key: "refs.refType",
            operation: PageFilterOperationEnum.EQUAL,
            value: ref.refType
          })
        );
      });
    }

    if (this.tags) {
      this.tags.forEach(tag => {
        filters.push(
          new PageFilterElement({
            key: "tagIds",
            operation: PageFilterOperationEnum.EQUAL,
            value: tag.id
          })
        );
      });
    }

    this.store.setFilters(filters);
  }

  get partner() {
    return PartnerModule.partner;
  }

  get controlElements(): IControlElements[] {
    return [
      ...this.additionalControlElements,
      {
        icon: "mdi-open-in-new",
        text: this.$t("sign.DocumentTable.open").toString(),
        action: this.open
      },
      {
        icon: "mdi-account-outline",
        text: this.$t("sign.DocumentTable.access").toString(),
        action: this.startUpdateIsInternal,
        disabled: this.partner.partnerType !== PartnerTypeEnum.BROKER
      },
      {
        icon: "mdi-file-sign",
        text: this.$t("sign.DocumentTable.sign").toString(),
        action: async ({ partnerId, id }: ISignDocument) => {
          await this.signRequestDialog.initializeForSignDocument(partnerId, id);
        },
        disabled: !UserModule.abilities.can(ActionEnum.READ, ResourceEnum.SIGN, this.partner.id)
      },
      {
        icon: "mdi-delete-outline",
        text: this.$t("sign.DocumentTable.delete").toString(),
        action: (item: ISignDocument) => {
          if (!item.isDeletable) {
            this.$toast.warning($t("sign.notDeletable"));

            return;
          }
          this.selected = [item];
          this.isDeleteDialogActive = true;
        },
        disabled: !UserModule.abilities.can(ActionEnum.READ, ResourceEnum.DOCUMENT, this.partner.id)
      }
    ];
  }

  goToSignRequest(document: ISignDocument) {
    this.selected = [document];
    this.createSignRequest = true;
  }

  async open(request: ISignDocument) {
    this.selectedDocument = null;
    this.$nextTick(() => {
      this.selectedDocument = request;
    });
  }

  async deleteDocument() {
    this.isDeleteDialogLoading = true;

    const request = this.selected[0];

    if (!request) {
      this.$toast.error("No Document selected");
    }

    await request.delete();

    this.isDeleteDialogLoading = false;
    this.isDeleteDialogActive = false;
  }

  async signRequestSaved(signRequest: ISignRequest) {
    this.createSignRequest = false;

    if (!signRequest) {
      return;
    }

    await this.$router.push({
      name: "SignRequestDetailView",
      params: { partnerId: signRequest.partnerId, signRequestId: signRequest.id }
    });
  }

  async save() {
    await this.store.fetchFirstPage({ partnerId: this.partner.id });
  }

  startUpdateIsInternal(document: ISignDocument) {
    this.documentToUpdate = document;
    this.documentManageAccessDialog = true;
  }
}
